export default __webpack_public_path__ + "static/media/sex-ON.cb7be70c.png";